import {
	API_START,
	API_END,
	FETCH_PUBLISH_EVENT,
	CLEAR_POST_PHOTO_DATA,
	SET_POST_DESCRIPTION_FR,
	SET_POST_DESCRIPTION_EN,
	SET_POST_PHOTO_DATA,
	SET_PUBLISH_EVENT_RESULT,
	SET_POST_ENGLISH,
	CLEAR_POST_VALIDATE,
	VALIDATE_POST_INPUTS,
	RESET_POST,
	SET_POST_TITLE_FR,
	SET_POST_TITLE_EN,
	SET_READY_TO_COPY_URL,
	CLEAR_READY_TO_COPY_URL,
	SET_POST_VIDEO_ID,
	SET_COMMUNITY_DETAILS,
	SET_POST_CHANNEL_ID,
	SET_POST_POST_DESCRIPTION_FR,
	SET_POST_POST_DESCRIPTION_EN,
	SET_POST_THUMBNAIL_URL,
	SET_POST_URL,
	SET_POST_FORM_DATA,
	RESET_DATA
} from "../actions/types";
import { t } from "../services/i18n";

const initialState = {
	isFetching: false,
	files: [],
	photoUri: null,
	title: null,
	description: null,
	postDescription: null,
	descriptionErrorMsg: null,
	lang: null,
	clearPostValidate: false,
	isValid: false,
	isEnglish: false,
	readyToCopyUrl: false,
	youtubeVideoId: null,
	publishResult: null,
	eventChannels: [],
	channelId: null,
	displayPreview: false,
	url: null,
	urlErrorMsg: null
};

function validateUrl(url) {
	try {
		new URL(url.startsWith("http") ? url : `https://${url}`);
		return true;
	} catch (_) {
		return false;
	}
}

export default function postReducer(state = initialState, action = {}) {
	switch (action.type) {
		case API_START:
			if (action.payload === FETCH_PUBLISH_EVENT) {
				return {
					...state,
					isFetching: true
				};
			}
			break;

		case RESET_DATA:
			return {
				...initialState
			};

		case RESET_POST:
			return {
				...initialState,
				eventChannels: state.eventChannels,
				channelId: state.channelId
			};

		case SET_POST_URL:
			return {
				...state,
				url: action.value,
				urlErrorMsg: null
			};

		case SET_POST_FORM_DATA:
			return {
				...state,
				...action.payload,
				descriptionErrorMsg: null,
				urlErrorMsg: null,
				clearPostValidate: false,
				isValid: false,
				publishResult: null
			};

		case SET_COMMUNITY_DETAILS: {
			const community = Object.values(action.entities?.communities || {})[0];
			if (
				!community?.organizationId &&
				community?.communitytype !== "Organization"
			)
				return state;
			const eventChannels = Object.values(action.entities.channels || {})
				.filter(
					channel =>
						channel.channeltype === "NeighborhoodEventChannel" ||
						(community.communitytype === "Organization" &&
							channel.channeltype === "OrganizationEventChannel")
				)
				.map(({ _id, communityId: { name } }) => ({ id: _id, name }));
			return {
				...state,
				eventChannels,
				channelId: eventChannels?.[0]?.id
			};
		}

		case SET_POST_POST_DESCRIPTION_FR:
			return {
				...state,
				postDescription: action.value
			};

		case SET_POST_POST_DESCRIPTION_EN: {
			const { postDescription, ...others } = state.lang?.en || {};

			return {
				...state,
				lang: {
					...(state.lang ?? {}),
					en: {
						postDescription: action.value,
						...(others ?? {})
					}
				}
			};
		}

		case SET_POST_THUMBNAIL_URL:
			return {
				...state,
				files: [],
				photoUri: action.value
			};

		case SET_POST_CHANNEL_ID:
			return {
				...state,
				channelId: action.payload
			};

		case SET_READY_TO_COPY_URL:
			return {
				...state,
				readyToCopyUrl: true
			};

		case CLEAR_READY_TO_COPY_URL:
			return {
				...state,
				readyToCopyUrl: false
			};

		case CLEAR_POST_VALIDATE:
			return {
				...state,
				clearPostValidate: true,
				descriptionErrorMsg: null,
				urlErrorMsg: null,
				isValid: false
			};

		case VALIDATE_POST_INPUTS:
			const urlErrorMsg =
				state.url && state.url.trim().length > 0 && !validateUrl(state.url)
					? t("template:urlbadformat")
					: null;
			const descriptionErrorMsg =
				state.description && state.description.trim().length > 0
					? null
					: t("live:descriptionmandatory");
			const isValid = !descriptionErrorMsg && !urlErrorMsg;
			return {
				...state,
				clearPostValidate: false,
				descriptionErrorMsg,
				isEnglish: descriptionErrorMsg ? false : state.isEnglish,
				isValid
			};

		case SET_POST_ENGLISH:
			return {
				...state,
				isEnglish: action.payload
			};

		case SET_POST_DESCRIPTION_FR:
			return {
				...state,
				description: action.value,
				descriptionErrorMsg: null
			};

		case SET_POST_DESCRIPTION_EN: {
			const { description, ...others } = state.lang?.en || {};

			return {
				...state,
				lang: {
					...(state.lang ?? {}),
					en: {
						description: action.value,
						...(others ?? {})
					}
				}
			};
		}

		case SET_POST_TITLE_FR:
			return {
				...state,
				title: action.value
			};

		case SET_POST_TITLE_EN: {
			const { title, ...others } = state.lang?.en || {};

			return {
				...state,
				lang: {
					...(state.lang ?? {}),
					en: {
						title: action.value,
						...(others ?? {})
					}
				}
			};
		}

		case CLEAR_POST_PHOTO_DATA:
			return {
				...state,
				files: [],
				photoUri: null,
				youtubeVideoId: null
			};

		case SET_POST_PHOTO_DATA:
			return {
				...state,
				files: action.files ? action.files : [],
				photoUri: action.value,
				youtubeVideoId: null
			};

		case SET_POST_VIDEO_ID:
			return {
				...state,
				files: [],
				photoUri: null,
				youtubeVideoId: action.value
			};

		case SET_PUBLISH_EVENT_RESULT:
			return {
				...state,
				publishResult: action.payload
			};

		case API_END:
			if (action.payload === FETCH_PUBLISH_EVENT) {
				return {
					...state,
					isFetching: false
				};
			}
			break;

		default:
			return state;
	}

	return state;
}
